<div class="turnstile-container" #container [ngClass]="size"></div>
